import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sdk-web', templateUrl: './web-sdk.component.html', styleUrls: ['./web-sdk.component.scss'], standalone: false })
export class WebSDKComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-globe' },
    { id: 'integration', label: 'Integration', icon: 'bx-code-alt' },
  ];
  features = [
    { icon: 'bx-globe', title: 'Framework Agnostic', desc: 'Works with React, Angular, Vue, and plain JS — import as an NPM package or via CDN.' },
    { icon: 'bx-map-pin', title: 'Live Vehicle Map', desc: 'Embeddable live vehicle tracking map component with clustering, history replay, and custom markers.' },
    { icon: 'bx-bar-chart-alt-2', title: 'Dashboard Widgets', desc: 'Pre-built data visualisation widgets for trip history, driver scores, and fleet health dashboards.' },
    { icon: 'bx-bell', title: 'Real-Time Events', desc: 'WebSocket-based real-time vehicle event streams for ignition, alerts, and telemetry updates.' },
    { icon: 'bx-shield', title: 'Token Auth', desc: 'OAuth 2.0 and API-key authentication with CORS, CSP, and XSS protection built-in.' },
    { icon: 'bx-code-curly', title: 'TypeScript Support', desc: 'Full TypeScript type definitions shipped with every release for a type-safe integration experience.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
